import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

@Component({
  selector: 'crm-app',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  loadingRouteConfig: boolean = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
    // <loader *ngIf="loadingRouteConfig"></loader>
    this.router.events.subscribe(event => {
      if(event instanceof NavigationStart) {
        if(event.url === '/reporting')
          this.loadingRouteConfig = true;
      }else if(event instanceof NavigationEnd) {
        setTimeout(() => {
          if(event.url === '/reporting')
            this.loadingRouteConfig = false;
        }, 2000);
      }
    });
  }

}
